import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_ADDDISH,
  REQUEST_CREATE_MASTER_ADDDISH,
  SET_MASTER_ADDDISH,
  SUCCESS_CREATE_MASTER_ADDDISH,
  ERROR_GET_MASTER_ADDDISH,
  ERROR_CREATE_MASTER_ADDDISH,
  SET_MESSAGE_MASTER_ADDDISH,
  SUCCESS_DELETE_MASTER_ADDDISH,
  SUCCESS_UPDATE_MASTER_ADDDISH,
  REQUEST_DELETE_MASTER_ADDDISH,
  REQUEST_UPDATE_MASTER_ADDDISH,
  ERROR_DELETE_MASTER_ADDDISH,
  ERROR_UPDATE_MASTER_ADDDISH,
} from "./adddishActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterAdddish: any[];
}

const initialState: IState = {
  busy: false,
  message: "",
  masterAdddish: [],
};

const adddish = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_ADDDISH:
    case REQUEST_CREATE_MASTER_ADDDISH:
    case REQUEST_DELETE_MASTER_ADDDISH:
    case REQUEST_UPDATE_MASTER_ADDDISH:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_ADDDISH:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_ADDDISH:
      return {
        ...state,
        busy: false,
        message: "",
        masterAdddish: action.payload,
      };

    case SUCCESS_CREATE_MASTER_ADDDISH:
      return {
        ...state,
        busy: false,
        message: "",
        masterAdddish: [...state.masterAdddish, action.payload],
      };
    case SUCCESS_DELETE_MASTER_ADDDISH:
      return {
        ...state,
        busy: false,
        message: "",
        masterAdddish: state.masterAdddish.filter(
          (tutorial) => get(tutorial, "_id") !== action.payload
        ),
      };

    case SUCCESS_UPDATE_MASTER_ADDDISH:
      return {
        ...state,
        busy: false,
        message: "",
        masterAdddish: state.masterAdddish.map((mp) => {
          return get(mp, "_id") === action.payload._id ? action.payload : mp;
        }),
      };

    case ERROR_GET_MASTER_ADDDISH:
    case ERROR_CREATE_MASTER_ADDDISH:
    case ERROR_UPDATE_MASTER_ADDDISH:
    case ERROR_DELETE_MASTER_ADDDISH:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };
    default:
      return state;
  }
};

export default adddish;

export function useAdddishMaster() {
  return useSelector((state: Record<string, any>) => state.adddish);
}
